<template>
  <div>
    <el-form
      ref="form"
      label-width="100px"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-form-item
        :label="$l('form_label_versionNo') || '版本号'"
        prop="versionNo"
      >
        <el-input
          clearable
          v-model="formData.versionNo"
          :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        :label="$l('form_label_publishDescription') || '发布说明'"
        prop="publishDescription"
      >
        <div>
          <quill-editor
            :disabled="disabled"
            v-model="formData.publishDescription"
            :options="editorOptions"
          />
        </div>
      </el-form-item>
    </el-form>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button type="primary" size="small" @click="save()">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
export default {
  props: {
    disabled: Boolean,
    versionCode: String,
  },
  components: {
    quillEditor,
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            {list: 'ordered'},
            {list: 'bullet'},
            {script: 'sub'},
            {script: 'super'},
            {color: []},
            {background: []},

            {size: ['small', false, 'large', 'huge']},
          ],
        },
      },
      backDialogVisible: false,
      formData: {versionStatus: 'N'},

      rules: {
        versionNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        publishDescription: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.versionCode) return
      this.$api
        .sysVersionDetailApi({
          versionCode: this.versionCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])

      let dscription
      if (this.formData.publishDescription) {
        dscription = this.formData.publishDescription
          .replace(/\n/g, '<br/>')
          .replace(/\s/g, '')
      }

      if (!result) {
        this.backDialogVisible = false
        return
      }
      this.formData.publishDescription = dscription

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .sysVersionSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.ql-editor {
  min-height: 200px;
}
</style>
